<template>
  <div
    :class="{
      'container mx-auto mt-6': true,
    }"
  >
    <h2>
      {{ title }}
    </h2>
    <p
      :class="{
        'text-center text-xs leading-7 text-www-color-neutral-medium-dark md:text-15px': true,
      }"
    >
      {{ subtitle }}
    </p>

    <slot />
  </div>
</template>

<script lang="ts" setup>
import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import { toRefs } from 'vue';
import TrackingUtil from '~/hekate-www/external/util/TrackingUtil';
import type UnifiedSignupSessionInfo from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/session-info/UnifiedSignupSessionInfo';
import type FreeDetails2SignupScreen from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/screens/FreeDetails2SignupScreen';
import type { UssProPlan } from '~/sanity/types';

const { signupScreen } = defineProps<
  UssProPlan & {
    signupScreen: FreeDetails2SignupScreen;
    sessionInfo: UnifiedSignupSessionInfo;
  }
>();

// Get field references
const cadAtWorkField = signupScreen.getField(FieldHtmlNameUtil.doYouUseCadAtWork);
const companyNameField = signupScreen.getField(FieldHtmlNameUtil.companyName);
const jobTitleField = signupScreen.getField(FieldHtmlNameUtil.jobTitle);

// Helper to hide company and job title fields
const hideFields = () => {
  companyNameField.componentName = 'hidden-field';
  companyNameField.isRequired = false;
  companyNameField.val = '';
  jobTitleField.componentName = 'hidden-field';
  jobTitleField.isRequired = false;
  jobTitleField.val = '';
};

// Initially hide fields
hideFields();

// Watch cadAtWork to show/hide company and job title fields
const cadAtWorkFieldVal = toRefs(cadAtWorkField).val;
watch(
  cadAtWorkFieldVal,
  (newVal, oldVal) => {
    if (newVal === 'no' && oldVal === 'yes') {
      TrackingUtil.mouseFlowPush(['tag', 'cadAtWorkYtoN']);
    }

    if (newVal === 'yes') {
      companyNameField.componentName = companyNameField.initialComponentName;
      companyNameField.isRequired = true;
      jobTitleField.componentName = jobTitleField.initialComponentName;
      jobTitleField.isRequired = true;
    } else {
      hideFields();
    }
  },
  { immediate: true }
);
</script>

<style></style>
